function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M4.64516 4.70968C7.78495 1.56989 11.5699 0 16 0C20.4301 0 24.1935 1.56989 27.2903 4.70968C30.4301 7.80645 32 11.5699 32 16C32 20.4301 30.4301 24.2151 27.2903 27.3548C24.1935 30.4516 20.4301 32 16 32C11.5699 32 7.78495 30.4516 4.64516 27.3548C1.54839 24.2151 0 20.4301 0 16C0 11.5699 1.54839 7.80645 4.64516 4.70968ZM29.9355 16C29.9355 12.129 28.5591 8.83871 25.8064 6.12903C23.0968 3.41935 19.828 2.06452 16 2.06452C12.129 2.06452 8.83871 3.44086 6.12903 6.19355C3.41935 8.90323 2.06452 12.172 2.06452 16C2.06452 19.871 3.41935 23.1613 6.12903 25.871C8.88172 28.5806 12.172 29.9355 16 29.9355C19.871 29.9355 23.1613 28.5806 25.871 25.871C28.5806 23.1183 29.9355 19.828 29.9355 16ZM20.3226 21.6774L15.0968 17.871C14.8817 17.7419 14.7742 17.5484 14.7742 17.2903V6.96774C14.7742 6.45161 15.0323 6.19355 15.5484 6.19355H16.4516C16.9677 6.19355 17.2258 6.45161 17.2258 6.96774V16.3871L21.8065 19.7419C22.1935 20.043 22.2366 20.3871 21.9355 20.7742L21.4194 21.5484C21.1183 21.9355 20.7527 21.9785 20.3226 21.6774Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6ff3bcc1e450238b3c9121f904a35227.svg";
export { ForwardRef as ReactComponent };